import React, { useState, useEffect, useRef } from 'react';
//import Preview from 'preview-url-component'
import LinkPreview from './LinkPreview';
import { Container, Col, Row } from 'reactstrap';
import companyLogo from './Images/logo-here.png';
import videoPlaceholder from './Images/basic-video-styles.jpg';
import TrainingVideo from '../Dashboard/Video/TrainingVideo';

const UnknownLandingPage = (props) => {
  return (
    <div id="unknownLandingPageContainer">
      <Col lg="12">
        <div id="unknownBorder">
          <Row>
            <Col>
              <h1>Company Name</h1>
            </Col>
            <Col className="text-right">
              <img id="companyLogo" src={companyLogo} alt="Company Logo" />
            </Col>
          </Row>
          <br />
          <br />
          <br />
          <Row>
            <Col style={{ paddingRight: '15px' }}>
              <h4>You have clicked through the following unknown link: </h4>
              <p id="clickedLink">http://theharpbarandrestaurant.com/</p>
              <p>Which directs to this site:</p>
              <LinkPreview
                loading={props.loading}
                title={props.title}
                desc={props.desc}
                img={props.img}
                url={props.url}
              />
              <p>Is this where you intended to go?</p>
            </Col>
          </Row>
          <Col style={{ paddingRight: '15px' }}>
            <div>
              <p>
                Your administrator would like to provide training on the risks and potential consequences of clicking
                through to unsafe links.
              </p>
              <br />
              <br />
            </div>
            <div>
              <p>
                (Placeholder text) If you feel this link should not be labelled unknown... push to LinkAnalysis where
                user can vote on safety?
              </p>
            </div>
          </Col>
        </div>
      </Col>
    </div>
  );
};
export default UnknownLandingPage;

//< img id = "videoPlaceholder" src = { videoPlaceholder } alt = "Training Video Placeholder" />
